const titleCase = (params) => {
	if (!params) { return; }
	return params
	  .toLowerCase()
	  .split(' ')
	  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
	  .join(' ');
};

export default {
	breed() {
		return {
			ERROR_GET_BREED_LIST: 'Unable to get breed list.',
			ERROR_GET_BREED_INFO: 'Unable to get health alert information.'
		}
	},
	pet(params) {
		return {
			// success
			SUCCESS_DELETE_PET: `Pet ${titleCase(params)} has been deleted.`,
			// error
			ERROR_GET_GENERAL_INFO: `Unable to get pet's general information.`,
			ERROR_GET_PET_DETAILS: 'Unable to get pet details.',
			ERROR_ADD_PET: 'Unable to add pet.',
			ERROR_UPDATE_PET: 'Unable to update pet details.',
			ERROR_DELETE_PET: `Unable to delete ${titleCase(params)} pet.`,
			SUCCESS_ADD_WEIGHT: `Succesfully added weight for ${params}.`,
			ERROR_ADD_WEIGHT: `Unable to add weight for ${params}.`,
			SUCCESS_EDIT_WEIGHT: `Succesfully updated weight for ${params}.`,
			ERROR_EDIT_WEIGHT: `Unable to update weight for ${params}.`
		}
	},
	treatment(params) {
		return {
			// success
			SUCCESS_DELETE_TREATMENT: `Treatment ${titleCase(params)} has been deleted.`,
			// error
			ERROR_GET_TREATMENT_LIST: 'Unable to get treatment list.',
			ERROR_ADD_TREATMENT: 'Unable to add treatment.',
			ERROR_DELETE_TREATMENT: `Unable to delete ${titleCase(params)} treatment.`,
			ERROR_APPLY_TREATMENT: `Unable to apply ${titleCase(params)} treatment.`
		}
	},
	brand() {
		return {
			ERROR_GET_BRAND_LIST: 'Unable to get brand list.'
		}
	},
	product() {
		return {
			ERROR_GET_PRODUCT_LIST: 'Unable to get product list.'
		}
	},
	user() {
		return {
			ERROR_UPDATE_USER: 'Unable to update user details.',
			SUCCESS_REMOVED_PROFILE: 'Succesfully removed walker or sitter profile.',
			SUCCESS_CREATED_PROFILE: 'Succesfully created walker or sitter profile.',
			SUCCESS_UPDATE_PROFILE: 'Profile Successfully Updated.',
			SUCCESS_UPDATE_BREED: 'Preferred Breed Successfully Updated.',
			SUCCESS_UPDATE_SCHEDULE: 'Schedule Successfully Updated.'
		}
	},
	password() {
		return {
			ERROR_CHANGE_PASSWORD: 'Incorrect current password.',
			ERROR_SET_PASSWORD: 'Unable to set password.',
			ERROR_RESET_PASSWORD: 'Unable to reset password.'

		}
	},
	post(params) {
		return {
			SUCCESS_DELETE_POST: 'Post has been deleted.',
			ERROR_SAVE_POST: 'Unable to save post.',
			ERROR_DELETE_POST: 'Unable to delete the post.',
			ERROR_UPDATE_POST: 'Unable to update the post.',
			ERROR_GET_POST: `Unable to get post.`
		}
	},
	comment(params) {
		return {
			ERROR_SAVE_COMMENT: 'Unable to save comment.',
			ERROR_UPDATE_COMMENT: 'Unable to update the comment.',
			ERROR_GET_COMMENT: `Unable to get ${params} comment.`
		}
	},
	report(params) {
		return {
			ERROR_REPORT_CONTENT: 'Unable to report this content.',
			ERROR_GET_REPORTED_LIST: 'Unable to get reported list.',
			SUCCESS_CONTENT_REPORTED: 'Content has been successfully reported.',
			SUCCESS_REPORT_CONTENT: `Reported Content has been ${titleCase(params)} for deletion.`,
		}
	},
	club(params) {
		return {
			ERROR_GET_USER_CLUB: 'Unable to get user club access.',
			ERROR_GET_CLUB_GROUP_LIST: 'Unable to get club group list.',
			ERROR_GET_CLUB_GROUP_MEMBER_BY_CUSTOMER_ID: 'Unable to get club group member details.',
			ERROR_UPDATE_GROUP_MEMBER_ACCESS: 'Unable to update member.',
			ERROR_REMOVE_GROUP_MEMBER: 'Unable to remove customer',
			ERROR_REQUEST_TO_JOIN_GROUP: 'Unable to send request',

			SUCCESS_UPDATE_GROUP_MEMBER_ACCESS_TITLE: 'Updated.',
			SUCCESS_UPDATE_GROUP_MEMBER_ACCESS_TEXT: 'Member updated.',
			SUCCESS_REMOVE_GROUP_MEMBER_TITLE: 'Removed.',
			SUCCESS_REMOVE_GROUP_MEMBER_TEXT: 'Customer removed.',
			SUCCESS_REQUEST_TO_JOIN_GROUP: `Request to join ${params.name} group has been sent.`,
			SUCCESS_REQUEST_TO_CANCEL_JOIN_GROUP: `Cancel join group request has been sent.`
		}
	},
	cart(params) {
		return {
			// delete
			SUCCESS_DELETE_CART: `Item has been removed from the cart.`,
			ERROR_DELETE_CART: `Unable to remove the item from the cart.`,
			// update
			SUCCESS_UPDATE_CART: `Your cart has been updated.`,
			ERROR_UPDATE_CART: `Unable to update your cart.`,
			// add
			SUCCESS_ADD_CART: `${titleCase(params)} has been added to cart.`,
			ERROR_ADD_CART: `Unable to add ${titleCase(params)} to cart.`
			
		}
	},
	publicCart(){
		return {
			// fetch
			ERROR_GET_PUBLIC_PRODUCTS_CART: 'Unable to get public cart products.',
		}
	},
	addressFinder() {
		return {
			ERROR_GET_ADDRESS: 'Unable to get address.'
		}
	},
	payment() {
		return {
			ERROR_CHARGE_PAYMENT: 'Unable to process payment'
		}
	},
	transactions() {
		return {
			ERROR_GET_CUSTOMER_ORDERS: 'Unable to get transactions.',
		}
	},
	order() {
		return {
			SUCCESS_CANCEL_ORDER: 'Refund request has been sent.',
			ERROR_CANCEL_ORDER: 'Unable to refund order.'
		}
	},
	subscription() {
		return {
			SUCCESS_REQUEST_CANCEL: 'Subscription request cancellation has been sent.',
			ERROR_REQUEST_CANCEL: 'Unable to request to cancel subscription.'
		}
	},
	reaction() {
		return {
			ERROR_SAVING_REACTION: 'Unable to save your reaction',
		}
	},
	reminder() {
		return {
			ERROR_GET_REMINDER_CLUB: 'Unable to get reminders.',
			ERROR_SAVE_REMINDER: 'Unable to save reminders.',
			ERROR_UPDATE_REMINDER: 'Unable to save reminders.',
			SUCCESS_SAVE_REMINDER: 'Successfully saved reminders.',
			SUCCESS_UPDATE_REMINDER: 'Successfully updated reminders.'
		}
	},
	document() {
		return {
			ERROR_GET_DOCUMENT: 'Unable to get document.',
			ERROR_GET_DOCUMENTS: 'Unable to get documents.',
			ERROR_UPDATE_REMINDER: 'Unable to update document.',
			ERROR_UPLOAD_DOCUMENT: 'Unable to upload document.',
			ERROR_DELETE_DOCUMENT: 'Unable to upload document.',
			SUCCESS_UPLOAD_DOCUMENT: 'Successfully uploaded document.',
			SUCCESS_UPDATE_DOCUMENT: 'Successfully updated document.',
			SUCCESS_DELETE_DOCUMENT: 'Successfully deleted document.',
			SUCCESS_SAVE_MICROCHIP: 'Successfully updated microchip.',
			SUCCESS_DELETE_MICROCHIP: 'Successfully deleted microchip.'
		}
	},
	exercise() {
		return {
			SUCCESS_ADDED_EXERCISE: 'Successfully Added Exercise.',
			SUCCESS_DELETED_EXERCISE: 'Successfully deleted Exercise.',
			SUCCESS_UPDATED_EXERCISE: 'Successfully updated Exercise.'
		}
	},
	purchase() {
		return {
			SUCCESS_ADDED_PURCHASE: 'Successfully Added Dog Purchase.',
			SUCCESS_DELETED_PURCHASE: 'Successfully deleted a Purchase.',
			SUCCESS_REQUEST_PURCHASE: 'Successfully requested a Purchase.'
		}
	},
	breeder() {
		return {
			// Success
			SUCCESS_BREEDER_REGISTERED: 'Successfully Registered as Breeder',
			// Error
			ERROR_BREEDER_EXISTS: 'You\'ve already registered as Breeder'
		}
	},
	puppySell() {
		return {
			// Success
			SUCESS_SAVE_PUPPY_DETAILS: 'Successfully added a puppy for sale.',
			// Error
			ERROR_SAVE_PUPPY_DETAILS: 'Failed to sent a Puppy Sell Request'
		}
	},
	damSire() {
		return {
			SUCCESS_ADD_DAM_SIRE: 'Successfully added a dam/sire.',
			ERROR_ADD_DAM_SIRE: 'Failed to add a dam/sire.',

			ERROR_GET_DAM_SIRE: 'Unable to get dam/sire details.',

			ERROR_GET_DAM_PREV_LITTERS_WHELP_TYPES_COUNT: 'Unable to get dam prev litters and whelp types count.',

			SUCCESS_UPDATE_DAM_SIRE: 'Successfully updated dam/sire details.',
			ERROR_UPDATE_DAM_SIRE: 'Failed to update dam/sire details.',
		}
	},
	damSireDocument() {
		return {
			SUCCESS_ADD_DAM_SIRE_DOCUMENT: 'Successfully uploaded document.',
			ERROR_ADD_DAM_SIRE_DOCUMENT: 'Failed to upload document.',

			SUCCESS_EDIT_DAM_SIRE_DOCUMENT: 'Successfully updated document.',
			ERROR_EDIT_DAM_SIRE_DOCUMENT: 'Failed to update document.',

			SUCCESS_DELETE_DAM_SIRE_DOCUMENT: 'Successfully deleted document.',
			ERROR_DELETE_DAM_SIRE_DOCUMENT: 'Failed to delete document.',

			ERROR_GET_DAM_SIRE_DOCUMENTS_LIST: 'Unable to get documents list.',
		}
	},
	mating() {
		return {
			SUCCESS_ADD_MATING: 'Successfully added mating details.',
			ERROR_ADD_MATING: 'Failed to add a mating details.',

			ERROR_GET_DAM_SIRE_LIST: 'Unable to get dam/sire list.',
			ERROR_GET_MATING_DETAILS: 'Unable to get mating details.',

			SUCCESS_UPDATE_MATING: 'Successfully updated mating details.',
			ERROR_UPDATE_MATING: 'Failed to update mating details.',

			SUCCESS_UPDATE_MATING_STATUS: 'Successfully updated mating status.',
			ERROR_UPDATE_MATING_STATUS: 'Failed to update mating status.',

			
			SUCCESS_ADD_WHELP_TYPE_OF_BIRTH: 'Successfully added whelping date and type of birth.',
			ERROR_ADD_WHELP_TYPE_OF_BIRTH: 'Failed to add whelping date and type of birth.',
		}
	},
	ovulationGestation(){
		return {
			SUCCESS_ADD_OVULATION_GESTATION: 'Successfully added ovulation and gestation details.',
			ERROR_ADD_OVULATION_GESTATION: 'Failed to ovulation and gestation details.',
			ERROR_FETCHING_PREVIOUS_OVULATION: 'Failed to fetch previous ovulation cycle.',
		}
	},
	litters(){
		return {
			SUCCESS_ADD_LITTER: 'Successfully added all litters.',
			SUCCESS_UPDATE_LITTER: 'Successfully updated puppy details.',
			ERROR_ADD_LITTER: 'Failed to add all litters.',

			ERROR_GET_LITTER_LIST:  'Unable to get transactions.',
		}
	},
	litterNotes() {
		return {
			ERROR_SAVE_NOTE: 'Unable to save litter note.',
			ERROR_UPDATE_NOTE: 'Unable to save litter note.',
			SUCCESS_SAVE_NOTE: 'Successfully saved litter note.',
			SUCCESS_UPDATE_NOTE: 'Successfully updated litter note.'
		}
	},
	matingAndCycle(){
		return {
			SUCCESS_ADD_MATING_AND_CYCLE: 'Successfully added mating details and cycle dates.',
			ERROR_ADD_MATING_AND_CYCLE: 'Failed to add mating details and cycle dates.',

			SUCCESS_UPDATE_MATING_AND_CYCLE: 'Successfully updated mating details and cycle dates.',
			ERROR_UPDATE_MATING_AND_CYCLE: 'Failed to update mating details and cycle dates.',
		}
	},
	waitlist(){
		return {
			SUCCESS_ALLOCATE_PUPPY: 'Successfully added allocation details.',
			ERROR_ALLOCATE_PUPPY: 'Failed to add allocation details.',

			SUCCESS_UPDATE_ALLOCATED_PUPPY: 'Successfully updated allocation details.',
			ERROR_UPDATE_ALLOCATED_PUPPY: 'Failed to updated allocation details.',

			ERROR_FETCHING_ALLOCATION_DETAILS: 'Failed to fetch allocation details.',

			SUCCESS_DELETE_WAITLIST: `Allocated puppy has been deleted.`,
			ERROR_DELETE_WAITLIST: `Unable to delete allocated puppy.`,
		}
	},
};
